import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SortDirection } from '@shared/enums';
import { ReportDownloadInProgress } from '@shared/models/dpr';
import { AppState } from '..';
import { AppActions } from '../actions';
import { appQuery } from '../app.selector';

@Injectable()
export class AppFacade {
  query = {
    sidebarStatus$: this.store.select(appQuery.getSidebarStatus),
    isFullScreenMode$: this.store.select(appQuery.isFullScreenMode),
    isAppOnline$: this.store.select(appQuery.isAppOnline),
    isAppOnlineRealState$: this.store.select(appQuery.isAppOnlineRealState),
    loginPageDisplayed$: this.store.select(appQuery.getLoginPageDisplayed),
    redirectedToCore$: this.store.select(appQuery.getRedirectedToCore),
    isLoading$: this.store.select(appQuery.isLoading),
    isAppLockedInOffline$: this.store.select(appQuery.isAppLockedInOffline),
    dprsSortingDirection$: this.store.select(appQuery.getDprsSortingDirection),
    reportDownloadsInProgress$: this.store.select(
      appQuery.getReportDownloadsInProgress
    ),
  };

  constructor(private store: Store<AppState>) {}

  toggleSidebar(): void {
    this.store.dispatch(AppActions.toggleSidebar());
  }

  toggleFullScreenMode(): void {
    this.store.dispatch(AppActions.toggleFullScreenMode());
  }

  setAppOnlineStatus(isAppOnline: boolean): void {
    this.store.dispatch(
      AppActions.setAppOnlineStatus({ appOnline: isAppOnline })
    );
  }

  setLoginPageDisplayed(loginPageDisplayed: boolean): void {
    this.store.dispatch(
      AppActions.setLoginPageDisplayed({ loginPageDisplayed })
    );
  }

  setRedirectedToCore(redirectedToCore: boolean): void {
    this.store.dispatch(AppActions.setRedirectedToCore({ redirectedToCore }));
  }

  showLoader(): void {
    this.store.dispatch(AppActions.showLoader());
  }

  hideLoader(): void {
    this.store.dispatch(AppActions.hideLoader());
  }

  setAppLockedInOffline(isAppLockedInOffline: boolean): void {
    this.store.dispatch(
      AppActions.setAppLockedInOffline({
        appLockedInOffline: isAppLockedInOffline,
      })
    );
  }

  setDprsSortingDirection(sortingDirection: SortDirection): void {
    this.store.dispatch(
      AppActions.setDprsSortingDirection({ sortingDirection })
    );
  }

  setReportDownload(reportDownload: ReportDownloadInProgress): void {
    this.store.dispatch(
      AppActions.setReportDownload({
        reportDownload,
      })
    );
  }

  clearReportDownload(dprDetailId: number): void {
    this.store.dispatch(
      AppActions.clearReportDownload({
        dprDetailId,
      })
    );
  }

  clearAppState(): void {
    this.store.dispatch(AppActions.clearAppState());
  }
}
